export default __webpack_public_path__ + "static/media/client15.d0d4c135.jpg";